"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
class AioLanguageSwitcher extends React.Component {
    constructor(props) {
        super(props);
        this.toggleActive = () => {
            this.setState({ active: !this.state.active });
        };
        this.handleChange = (e) => {
            e.preventDefault();
            this.props.setSelectedLanguage(e.currentTarget.id);
        };
        this.state = {
            active: false,
        };
    }
    render() {
        return (React.createElement("div", { className: `aio-language-switcher ${this.state.active ? 'aio-language-switcher-active' : ''}`, onClick: this.toggleActive },
            React.createElement("div", { className: "selected-language" }, this.props.getSelectedLanguageName()),
            React.createElement("ul", { className: "language-dropdown" }, this.props.supportedLanguages.map((language) => (React.createElement("li", { key: language.languageCode },
                React.createElement("a", { href: "#", className: "selectItem", id: language.languageCode, onClick: this.handleChange }, language.name)))))));
    }
}
exports.default = AioLanguageSwitcher;
//# sourceMappingURL=AioLanguageSwitcher.js.map